export class Team {
    id: number;
    name: string;
    status: string;
    isDeleted: boolean = false;
    serviceAreaIdList:[];
    typeOfTeam:string;
    groupid:number;
    teamUserMapping:Array<TeamUser>
}

export class TeamUser{
    isAssignable: boolean;
    teamId: number;
    staffId: number;

    //for angular use
    staffName:string;
    empCode:string;
}